import { Outlet } from 'react-router-dom';

import { Card, CardContent, CardHeader } from '@/components/ui/card';
import Container from '@/components/ui/container';
import Logo from '@/components/ui/Logo';
import Row from '@/components/ui/row';

const AuthLayout = () => {
  return (
    <div className='box-border outline-0 relative'>
      <div className='min-h-screen'>
        <div className="bg-[url('/imgs/auth/overlay.svg')] bg-cover bg-center bg-no-repeat w-full h-screen">
          <Container className='h-full'>
            <Row className='h-full'>
              <div className='flex items-center justify-center h-full w-full'>
                <Card className='w-full max-w-3xl mx-4 sm:mx-0 md:p-16 '>
                  <CardHeader>
                    <div className='flex flex-col items-center justify-center'>
                      <Logo />
                    </div>
                  </CardHeader>

                  <CardContent>
                    <Outlet />
                  </CardContent>
                </Card>
              </div>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
